import {Component, Input, OnInit} from '@angular/core';
import {BreadcrumbService} from '@services/breadcrumb/breadcrumb.service';
import {MenuNotificationService} from '@services/menu-notification/menu-notification.service';
import {MenuItem} from '@models/sidebar/menu-item';

@Component({
    selector: 'scitis-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    standalone: false
})
export class BreadcrumbComponent implements OnInit {

  @Input()
  breadcrumbRoutes: any[] = [];

  constructor(private breadcrumbService: BreadcrumbService,
              private menuNotificationService: MenuNotificationService) {
  }

  ngOnInit() {
    this.breadcrumbRoutes = this.breadcrumbService.shortenRoutes(this.breadcrumbRoutes);
  }

  get showBreadcrumb(): boolean {
    return this.breadcrumbRoutes.length > 1;
  }

  getCursorStyle(breadCrumbRoute: MenuItem): string {
    if (this.shouldNotRoute(breadCrumbRoute)) {
      return 'cursor: default';
    }
    return 'cursor: pointer';
  }

  focusOnLeftMenu(breadcrumbRoute: MenuItem) {
    if (this.shouldNotRoute(breadcrumbRoute)) {
      return;
    }
    this.menuNotificationService.broadcastClickOnBreadcrumb(breadcrumbRoute);
  }

  public shouldNotRoute(breadcrumbRoute: MenuItem): boolean {
    return breadcrumbRoute.name === '...' || this.breadcrumbRoutes[this.breadcrumbRoutes.length - 1].id === breadcrumbRoute.id;
  }

}
